<template>
  <div class="screen-four-leaf-clover" :style="{backgroundImage: `url(${$$FormData.bgImage.src})`}">
    <div class="screen-four-leaf-clover--title">
      {{ $$FormData.title }}
    </div>
    <div class="screen-four-leaf-clover--gird">
      <a
        v-for="item in $$FormData.blocks"
        :key="item.__key"
        :href="$$GetLinkValue(item.link).href"
        :target="$$GetLinkValue(item.link).target"
        class="gird-item"
      >
        <div class="gird-item-inner">
          <div class="title-item">
            <div class="icon-item">
              <img v-if="item.image" :src="item.image.src" class="icon-item-img" :alt="item.title"/>
            </div>
            <span class="title-item-text">{{ item.title }}</span>
          </div>
          <div class="subtitle-item">{{ item.sub_title }}</div>
        </div>
      </a>
      <div v-if="!$$FormData.blocks.length" class="screen-four-leaf-clover--gird-empty">请添加Block</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ScreenFourLeafCloverPreview'
}
</script>

<style lang="scss" scoped>
.screen-four-leaf-clover {
  position: relative;
  width: 100%;
  padding: 50px 10px 100px 10px;
  box-sizing: border-box;
  background-size: cover;
  background-position: 50% 50%;
  background-repeat: no-repeat;
  background-clip: padding-box;
  background-attachment: scroll;
  overflow: hidden;
  &::before {
    content: "";
    position: absolute;
    z-index: 1;
    pointer-events: none;
    top: -0px;
    left: -0px;
    width: calc(100% + 0px + 0px);
    height: calc(100% + 0px + 0px);
    border-color: inherit;
    background-image: linear-gradient(90deg, rgba(8, 8, 8, 0.34) 0%, rgba(3, 3, 3, 0.51) 100%);
    opacity: 1;
  }
  &--title {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 1210px;
    margin: 0 auto;
    color: #ffffff;
    font-size: 34px;
    line-height: 1.4;
    font-weight: bold;
    padding: 10px;
  }
  &--gird {
    display: flex;
    flex-wrap: wrap;
    row-gap: 30px;
    column-gap: 20px;
    width: 1210px;
    margin: 20px auto 0;
    &-empty {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;
      height: 100px;
      color: #999999;
      font-size: 24px;
    }
  }
  .gird-item {
    width: calc((100% - 40px) / 2);
    padding: 40px;
    background-color: #ffffff;
    box-sizing: border-box;
    border-radius: 10px;
    transition: all .2s ease-out;
    box-shadow: 3px 8px 12px 0 #00000070;
    background-color: rgba(5, 5, 5, 0.88);
    &:hover {
      box-shadow: none;
    }
    &-inner {
      width: 100%;
    }
    .icon-item {
      width: 42px;
      height: 42px;
      padding-bottom: 10px;
      margin-right: 10px;
      .icon-item-img {
        width: 100%;
        height: 100%;
      }
    }
    .title-item {
      display: flex;
      align-items: center;
      color: #ffffff;
      font-size: 18px;
      font-weight: bold;
      line-height: 1.5;
    }
    .title-item-text {
      margin-top: 5px;
    }
    .subtitle-item {
      color: #ffffff;
      font-size: 15px;
      font-weight: 400;
      line-height: 1.8;
      margin-top: 10px;
    }
  }
}
</style>
